//Margin conventions
var margin = {top: 15, right: 132, bottom: 20, left: 5};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 350 - margin.top - margin.bottom;

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
  .attr("width", width + margin.left + margin.right)
  .attr("height", height + margin.top + margin.bottom)
  .append("g")
  .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.scale.linear()
  .range([0,width]);

//Creates the yScale
var y0 = d3.scale.ordinal()
  .rangeBands([height, 0], 0)
  .domain(["Digital Realty", "Iron Mountain", "Johnson & Johnson", "Walmart", "Switch Supernap", "3M", "Dow Chemical", "Google", "Microsoft", "Amazon"]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
  .scale(y0)
  .tickSize(-width)
  .tickPadding(4)
  .ticks(4)
  .orient("left");

//Defines the y axis styles
var xAxis = d3.svg.axis()
  .scale(xScale)
  .tickPadding(8)
  .orient("bottom")
  .tickSize(height)
  .ticks(6); 

//Loads the data
d3.csv("data/power.csv", ready);

function ready(err, data) {

  if (err) throw "error loading data";

  //FORMAT data
  data.forEach(function(d) {
    d.wind = +d.wind;
    d.solar = +d.solar;
  });

  //Sets the max for the xScale
  var maxX = d3.max(data, function(d) { return d.wind; });

  //Defines the xScale max
  xScale.domain([0, maxX ]);

  //Appends the y axis
  var yAxisGroup = svg.append("g")
    .attr("class", "y axis")
    .call(yAxis); 

  //Appends the x axis    
  var xAxisGroup = svg.append("g")
    .attr("class", "x axis")
    .attr("transform", function(d) {
      return "translate(125,0)";
    })
    .call(xAxis)
    .selectAll("g")
    .classed("g-baseline", function(d) {return d == 0});

  //Binds the data to the bars      
  var categoryGroup = svg.selectAll(".g-category-group")
    .data(data)
    .enter()
    .append("g")
    .attr("class", "g-category-group")
    .attr("transform", function(d) {
      return "translate(125," + y0(d.company) + ")";
    });

  //Appends first bar   
  var bars = categoryGroup.append("rect")
    .attr("width", function(d) { return xScale(d.solar); })
    .attr("height", y0.rangeBand()/1.5 )
    .attr("class", "g-wind")
    .attr("transform", "translate(0,4)");

  //Appends second bar   
  var bars2 = categoryGroup.append("rect")
    .attr("width", function(d) { return xScale(d.wind); })
    .attr("height", y0.rangeBand()/1.5 )
    .attr("class", "g-solar")
    .attr("transform", "translate(0,4)");        

//RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 15, right: 132, bottom: 0, left: 5};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Update the bars
    bars
      .attr("width", function(d) { return xScale(d.solar); });

     bars2
      .attr("width", function(d) { return xScale(d.wind); });  

    //Updates xAxis
    d3.selectAll(".x.axis")
         .call(xAxis);     

    //Updates ticks
    xAxis
      .scale(xScale)
      .ticks(6);

    //Updates yAxis
    d3.selectAll(".y.axis")
      .call(yAxis); 

    yAxis
      .tickSize(-newWidth);

  };

}